import { AuditMatch } from '@mi-front/core';
import { apiClient } from '../../../../../../../../api';
import { useTimezone } from '@app/core/hooks/useTimezone';
import { getAuditListingDefaultDateRange } from '@app/modules/audit/modules/station-audit/helpers/default-listing-date-range';
import { ReportView } from '../../../../../../../../core/reports/components/ReportView';
import { SpotMatchesForm } from './SpotMatchesForm';
import { SpotMatchesList } from './SpotMatchesList';
import { filterSpotMatchesByScheduleMeta } from './filter-spot-matches';
import { SpotMatchesListing } from './types';
import { Station } from '@app/core/types/stations';

type Props = {
  station: Station;
};

export function SpotMatchesView(p: Props) {
  const tz = useTimezone();

  return (
    <ReportView<SpotMatchesListing>
      runOnLoad
      queryParamsTransform={{
        customId: {
          parse: (input) => input,
          serialize: (input) => input.replace(/\s/g, ''),
        },
      }}
      defaultValues={{
        ...getAuditListingDefaultDateRange(tz),
        customId: '',
        order: '',
        version: '',
      }}
      download={false}
      reportFn={async (values) => {
        const { results, metadata } = await apiClient.audit.fetchMatches({
          stationId: p.station.id,
          filter: {
            from: values.from,
            to: values.to,
            customId: values.customId
              ?.split(',')
              .filter((value) => !!value)
              .map((value) => value.trim())
              .join(','),
          },
          pageSize: 9999,
        });

        const matches: AuditMatch[] = filterSpotMatchesByScheduleMeta(
          [...results].sort((m1, m2) => (new Date(m1.datetime) >= new Date(m2.datetime) ? -1 : 1)),
          values,
        );
        const hasScheduleMetaFilter = Boolean(values.order?.trim() || values.version?.trim());

        return {
          results: matches,
          total: hasScheduleMetaFilter ? matches.length : metadata.totalCount,
        };
      }}
      Form={SpotMatchesForm}
      Result={SpotMatchesList}
    />
  );
}
